import { render, staticRenderFns } from "./labelListPage.vue?vue&type=template&id=13252b78&scoped=true"
import script from "./labelListPage.vue?vue&type=script&lang=js"
export * from "./labelListPage.vue?vue&type=script&lang=js"
import style0 from "./labelListPage.vue?vue&type=style&index=0&id=13252b78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13252b78",
  null
  
)

export default component.exports